// See the 'DocumentLibraryFile' Django model on the backend
export const DOCUMENT_LIBRARY_CHAT_DIR = 'Files shared in chat/';